var _desc, _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureRestrictionOrifice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 280",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Restriction orifice in a liquid pipe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "A restriction plate with a circular hole installed across a pipe, showing flow and upstream and downstream pressure.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10 5-10 5z",
    fill: "#001e1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#001e1d",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 57h412v166H54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 83h412M54 197h412",
    stroke: "#86ceb2",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 58v60M250 162v60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 58v60M270 162v60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 140h88",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 140h88",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 118v44",
    markerStart: "url(#arrow)",
    markerEnd: "url(#arrow)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 118h25M270 162h25",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 96v30M418 96v30",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#001e1d",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 130
  }, "Q"), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 130
  }, "Q"), /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 91
  }, "p\u2081"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 91
  }, "p\u2082"), /*#__PURE__*/React.createElement("text", {
    x: 302,
    y: 146
  }, "d\u2082"), /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 250
  }, "orifice plate"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureRestrictionOrifice);
export default __webpack_public_path__ + "static/media/calc-figure-restriction-orifice.4a5905252956fa1c11ccff57530a3f00.svg";
export { ForwardRef as ReactComponent };